import dayjs from 'dayjs';
import { StorageKey } from 'types/storage/storage-key.enum';

export const setEmailSendTime = (): void => {
  localStorage.setItem(StorageKey.EmailSendTime, dayjs().toString());
};
